import axios from "axios";
import { contact_circle_validate } from "../../Imgs/images";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import "./Contact.css";
import { useState } from "react";

function Contact() {
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [message, setMessage] = useState("");
  const [cgu, setCgu] = useState(false);

  const sendMail = async () => {
    console.log("send mail");
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_MAIL_ENDPOINT}/api/sendMail.php`,
        {
          lastname: lastName,
          firstname: firstName,
          email,
          phone,
          companyname: companyName,
          message,
          cgu,
        },
      );

      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <div className="contact-page">
        <section className="contact-form">
          <form
            className="contact-form-submission"
            method="POST"
            onSubmit={() => sendMail()}
          >
            <div className="contact-submission-row">
              <div className="contact-submission-row-group">
                <label htmlFor="lastname">
                  <span>Nom</span>
                  <span>*</span>
                </label>
                <input
                  type="text"
                  name="lastname"
                  id="lastname"
                  placeholder="Votre nom"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
              <div className="contact-submission-row-group">
                <label htmlFor="firstname">
                  <span>Prénom</span>
                  <span>*</span>
                </label>
                <input
                  type="text"
                  name="firstname"
                  id="firstname"
                  placeholder="Votre Prénom"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="contact-submission-row">
              <div className="contact-submission-row-group">
                <label htmlFor="email">
                  <span>Email</span>
                  <span>*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="example@gmail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="contact-submission-row-group">
                <label htmlFor="phone">
                  <span>Téléphone</span>
                </label>
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="+33 X XX XX XX XX"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
            <div className="contact-submission-row-group">
              <label htmlFor="companyname">
                <span>Raison sociale</span>
                <span>*</span>
              </label>
              <input
                type="text"
                name="companyname"
                id="companyname"
                placeholder="Votre nom de société"
                required
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
            <div className="contact-submission-row-group">
              <label htmlFor="message">
                <span>Message</span>
              </label>
              <textarea
                name="message"
                id="message"
                placeholder="Votre message"
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            <div className="contact-submission-inline-row-group">
              <input
                type="checkbox"
                name="cgu"
                required
                id="cgu"
                checked={cgu}
                onChange={() => setCgu(!cgu)}
              />
              <label htmlFor="cgu">
                En cochant cette case, j'accepte que mes données soit partagées
                avec l'entreprise Soudry Préventions et Équipements.
              </label>
            </div>
            <button type="submit" className="contact-submission-submit-btn">
              <span>Envoyer le message</span>
              <div className="contact-submission-submit-btn-arrow"></div>
            </button>
          </form>
        </section>
        <section className="contact-informations">
          <h1 className="contact-informations-title">Nous contacter</h1>
          <div className="contact-informations-container">
            <div className="contact-informations-group">
              <h3 className="contact-informations-group-title">
                Adresse postale :
              </h3>
              <span>1690 Rue Aristide Briand, 76650 Petit-Couronne</span>
            </div>
            <div className="contact-informations-group">
              <h3 className="contact-informations-group-title">Téléphone :</h3>
              <span>+33 6 85 01 39 28 / +33 2 35 18 14 10</span>
            </div>
            <div className="contact-informations-group">
              <h3 className="contact-informations-group-title">Email :</h3>
              <span>contact@spenormandie.fr</span>
            </div>
          </div>
          <div className="contact-informations-cgu">
            <input
              type="checkbox"
              name="cgu-indirect"
              data-indirect="cgu"
              id="cgu-indirect"
              checked={cgu}
              onChange={() => setCgu(!cgu)}
            />
            <label htmlFor="cgu-indirect">
              En cochant cette case, j'accepte que mes données soit partagées
              avec l'entreprise Soudry Préventions et Équipements.
            </label>
          </div>
          <button
            type="submit"
            className="contact-submission-submit-btn contact-informations-btn"
            onClick={() => sendMail()}
          >
            <span>Envoyer le message</span>
            <div className="contact-submission-submit-btn-arrow"></div>
          </button>
        </section>
        <div className="contact-notification">
          <picture className="contact-notification-validate-img">
            <source srcSet={contact_circle_validate} />
            <img
              src={contact_circle_validate}
              alt="cercle avec une coche de validation à l'intérieur"
            />
          </picture>
          <span className="contact-notification-validate-msg">
            Votre message a bien été envoyé
          </span>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
